import React from 'react';
import PropTypes from 'prop-types';

const ClipPath = ({ fill }) => {
  return (
    <path
      fill={fill}
      d="M15.533 14.075l10.256-6.221a2.441 2.441 0 0 1 2.991.361.5.5 0 0 1-.056.756L18.71 16.378l10.514 7.776a.5.5 0 0 1 .056.756 2.441 2.441 0 0 1-2.991.36l-11.397-6.912-.108.073-3.456 2.335c1.287 2.142.682 4.915-1.46 6.362-2.262 1.527-5.38.997-6.963-1.185-1.583-2.182-1.034-5.188 1.228-6.716a5.155 5.155 0 0 1 5.093-.369L13.457 16l-4.232-2.858a5.153 5.153 0 0 1-5.093-.369c-2.262-1.528-2.81-4.535-1.228-6.716C4.49 3.875 7.605 3.345 9.867 4.872c2.142 1.447 2.748 4.22 1.461 6.362l3.455 2.335.75.506zM7.01 11.334c1.432 0 2.592-1.12 2.592-2.5 0-1.381-1.16-2.5-2.592-2.5-1.431 0-2.592 1.119-2.592 2.5 0 1.38 1.16 2.5 2.592 2.5zm0 14.333c1.432 0 2.592-1.12 2.592-2.5s-1.16-2.5-2.592-2.5c-1.431 0-2.592 1.12-2.592 2.5s1.16 2.5 2.592 2.5z"
    />
  );
};

ClipPath.propTypes = {
  fill: PropTypes.string,
};

export default ClipPath;



// WEBPACK FOOTER //
// ./src/icon/svgs/video-features/clip.jsx